import * as AmazonCognitoIdentity from "amazon-cognito-identity-js";
import { jwtDecode } from "jwt-decode";

const signInCognito = (username, password) => {
  const authenticationData = {
    Username: username,
    Password: password,
  };
  const authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
    authenticationData
  );
  const poolData = {
    UserPoolId: process.env.REACT_APP_USER_POOL_ID,
    ClientId: process.env.REACT_APP_CLIENT_ID,
  };

  const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
  const userData = {
    Username: username,
    Pool: userPool,
  };
  const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
  return new Promise((resolve, reject) => {
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (results) => {
        try {
          const jwtToken = results.accessToken.jwtToken;
          const cognitoUserData = jwtDecode(jwtToken);
          const response = {
            status: "SUCCESS",
            username: cognitoUserData?.username,
            accessToken: jwtToken,
          };
          resolve(response);
        } catch (err) {
          reject(err.message || JSON.stringify(err));
        }
      },
      onFailure: (err) => {
        reject(err.message || JSON.stringify(err));
      },
      newPasswordRequired: (userAttributes) => {
        // the api doesn't accept this field back needs to be removed
        delete userAttributes.email_verified;

        const response = {
          status: "NEW_PASSWORD_REQUIRED",
          challengeUserAttributes: userAttributes,
          cognitoUser: cognitoUser,
        };
        resolve(response);
      },
    });
  });
};

export default signInCognito;
